import React from "react";
import Loading from "../../../../common/components/Loading";
import NumberAssociatedCustomersContextProvider, { ACTIONS, NumberAssociatedCustomersContext } from "../../context/NumberAssociatedCustomersContextProvider"
import {  } from "../../../../common/utils/utilsFunc";
import { useModal } from "@clayui/modal";
import AlertModal from "../../../../common/components/AlertModal";
import { CGE } from "../../../../common/components/CGE";
import { getPageLayoutType } from '../../../../common/utils/utilsFunc';
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const NumberAssociatedCustomers = ({ props }) => {
    const [state, dispatch] = React.useContext(NumberAssociatedCustomersContext)
    const [loading, setLoading] = React.useState(false);
    const [form, setForm] = React.useState();
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [validForm, setValidForm] = React.useState({});
    const [modalInfo, setModalInfo] = React.useState({});
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModalInfo, setVisibleModalInfo] = React.useState(false);
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    const [optionsRelationsSelect, setOptionsRelationsSelect] = React.useState([{
        label: "[Seleccione una opción]",
        value: "",
    }]);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModalInfo(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    React.useEffect(() => {
        if(state?.relations) {
            let auxArrRelation = [{
                label: "[Seleccione una opción]",
                value: "",
            }];

            state.relations.map((obj,i) => {
                auxArrRelation.push({ label:obj, value: obj})
            })
            setOptionsRelationsSelect(auxArrRelation)
        }
    },[state.relations]);

    let optionsIdsSelect = [];
    
    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModalInfo,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModalInfo,
        "titleHint": "Información",
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function validInputForm() {

        let validForm = {};

        if (!form?.numberClient) {
            validForm.validateNumberClient = true;
            validForm.msgNumberClient = "Debes ingresar el N° de Cliente";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (detailClientJson?.length === 0) {
            validForm.validateNumberClient = true;
            validForm.msgNumberClient = "Debe hacer clic en Buscar!";
            props.setGlobalAlert("Debe hacer clic en Buscar!","warning");
        }

        if (!form?.relation) {
            validForm.validateRelation = true;
            validForm.msgRelation = "Debes ingresar la Relación";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }

        if (!form?.nameAccount) {
            validForm.validateNameAccount = true;
            validForm.msgNameAccount = "Debes ingresar el Nombre de la Cuenta";
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        }
        
        if(!verifReCaptcha) {
            validForm.validateVerifReCaptcha = true;
            props.setGlobalAlert("Por motivos de seguridad necesitamos validar que no eres un Robot.","warning");
        }

        setValidForm(validForm);
        return validForm;
    }

    function handleClick() {
        const validForm = validInputForm();
        
        if(Object.keys(validForm)?.length === 0) {
            setLoading(true);
            dispatch({
                payload: form,
                type: ACTIONS.SET_FORM,
            })
        } else if(validForm === {}) {
            props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
        }
    }

    React.useEffect(() => {
        setLoading(false);
        if(state.formResponse) {
            const objResponse = state.formResponse;
            if(objResponse?.data?.status === 201 || objResponse?.data?.status === 200 || objResponse?.response?.status === 201 || objResponse?.response?.status === 200 ) {
                props.setGlobalAlert("¡Número de cliente asociado con éxito!", "success", true, "Exito!");
                setForm({...form,nameAccount:"",numberClient:"",relation:"",valueCheckBoxSubscription:false });
            } else if(objResponse?.data?.status === 302) {
                props.setGlobalAlert("El número de cliente que ingresaste ya lo tienes registrado.", "warning", true, "Advertencia");
            } else {
                props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning", true, "Advertencia");
            }
        } 
    },[state.formResponse] )

    function openModalReadMore() {
        let auxMsgModal = state?.webContentTextReadMore?.length === 0?"":state?.webContentTextReadMore
        setModalInfo({titleModal:"Información",msgModal:auxMsgModal,status:"info"});
        setVisibleModal(true);
    }

    if (getPageLayoutType() && state?.idList && !state?.idList?.status) {
        optionsIdsSelect = [
            {
                label: "[Seleccione una opción]",
                value: "",
            }
        ];
        state?.idList?.forEach((id) => {
            optionsIdsSelect.push({ label: id, value: id });
        });
    }

    function handleClickClient() {
        if(form?.numberClient) {
            setLoading(true);

            dispatch({
                payload: form?.numberClient,
                type: ACTIONS.SET_CTA_CTO,
            })
        } else {
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
            setValidForm({...validForm,validateNumberClient : true,msgNumberClient : "Debes ingresar el N° de Cliente"})
        }
    }

    React.useEffect(() => {
        if(state.detailClient){
          setLoading(false)
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {

            if(validForm.validateNumberClient) {
                const auObj = validForm;
                delete auObj.msgNumberClient;
                delete auObj.validateNumberClient;
            }

            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
              setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
            } else {
                setDetailClientJson([])
                if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN !== 0 && state.detailClient.status !== 500){
                    dispatch({
                        payload: '',
                        type: ACTIONS.SET_CTA_CTO,
                    })
                    props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : props.text_fetch_error ,"warning", true, "Advertencia");
                }
            }
          } else {
                    dispatch({
                        payload: '',
                        type: ACTIONS.SET_CTA_CTO,
                    })
            setDetailClientJson([])
            props.setGlobalAlert(props.text_fetch_error,"warning", true, "Advertencia");
          }
        }
    }, [state.detailClient]);
    
    React.useEffect(() => {
        if(form?.numberClient) {
            setDetailClientJson([])
        }
    },[form?.numberClient])

    return (
        <>
            <CGE.Panel title={props.title_page_number_associated_customers} description={props.description_page_number_associated_customers}>
                <CGE.PanelSection title={props.subtitle_page_number_associated_customers}>
                    <div className="row">
                        <div className="col-md-12">
                            <CGE.DetailClient
                                props={{
                                    handleChange: (event) => {
                                        setForm({...form,numberClient:event.target.value })
                                    },
                                    hasError: validForm?.validateNumberClient,
                                    msgError: validForm.msgNumberClient,
                                    idFormElement: "CuentaContrato",
                                    labelName: "Número de Cliente:",
                                    mandatoryElement: true,
                                    idClient:form?.numberClient,
                                    propsLabelInfoContent: propsLabelInfoContent,
                                    valuePub: form?.numberClient,
                                    placeholder: "Número de Cliente",
                                    labelButton: "Buscar",
                                    handleClick: () => { handleClickClient() },
                                    sizeButton: "sm",
                                    typeButton: "primary",
                                    versionButton:"button",
                                }}
                                inputText={true}
                                propsDetail={{
                                    fullNameClient: (detailClientJson?.PRIMER_NOMBRE_PERSONA || detailClientJson?.SEGUNDO_NOMBRE_PERSONA
                                        || detailClientJson?.APELLIDO_PERSONA) ? `${detailClientJson?.PRIMER_NOMBRE_PERSONA} 
                                        ${detailClientJson?.SEGUNDO_NOMBRE_PERSONA} ${detailClientJson?.APELLIDO_PERSONA}` : "",
                                    comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
                                    calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
                                    nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
                                    dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
                                    ${detailClientJson?.PISO}` : "",
                                    ctaCtoClient: detailClientJson?.CTA_CTO
                                }}
                            />
                        </div>
                        
                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => setForm({...form,nameAccount:e.target.value })}
                                idFormElement="inputNameAccount"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="text"
                                labelName="Nombre de la Cuenta:"
                                placeholder="Nombre de la Cuenta"
                                inputExemple="* Ej. Casa Mamá."
                                hasError={validForm?.validateNameAccount}
                                msgError={validForm?.msgNameAccount && validForm?.validateNameAccount?validForm?.msgNameAccount:""}
                                value={form?.nameAccount}
                                maxLength={40}
                            />
                        </div>
                        <div className="col-md-4">
                            <CGE.FormsField
                                labelName="Relación con número del cliente: "
                                handleChange={(e) => setForm({...form,relation:e.target.value })}
                                idFormElement="numberRelation"
                                typeFormElement="text"
                                mandatoryElement={true}
                                typeElement={'select'}
                                listOptions={optionsRelationsSelect}
                                hasError={validForm.validateRelation}
                                msgError={validForm.msgRelation}
                                placeholder={'Relación con número del cliente'}
                                value={form?.relation}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.FormsField
                    checked={form?.valueCheckBoxSubscription}
                    labelName="Deseo suscribirme al envío por correo electrónico de la boleta/factura"
                    handleChange={() => setForm({...form,valueCheckBoxSubscription:!form?.valueCheckBoxSubscription})}
                    idFormElement="inputCheckBoxSubscription"
                    typeFormElement="checkbox"
                    mandatoryElement={false}
                    typeElement="input"
                />
                <CGE.Text
                    size="4"
                    text={props.info_send_email_page_number_associated_customers}
                />
                <a onClick={() => openModalReadMore()} >LEER MÁS</a>
                <CGE.Spacing type="nl" />
                <CGE.FieldRecaptcha
                    onChange={onChangeReCaptcha}
                    sitekey={props.api_key_recaptcha}
                /> 
                <div className='col-md-12 pt-2 d-flex justify-content-between'>
                    <CGE.Button
                        size="sm"
                        label="Cancelar"
                        onClick={() => { window.history.back() }}
                        type="secondary"
                    />
                    <CGE.Button
                        size="sm"
                        label="Aceptar"
                        onClick={() => handleClick()}
                    />
                </div>
            </CGE.Panel>
            {visibleModal && !loading && (
                <AlertModal
                    titleModal={modalInfo?.titleModal}
                    msgModal={modalInfo?.msgModal}
                    observer={observer}
                    onClose={onClose}
                    status={modalInfo?.status}
                />
            )}
            {loading && <Loading />}
        </>
    );
};

const NumberAssociatedCustomersWithProvider = ({
    props

}) => (
    <NumberAssociatedCustomersContextProvider>
        <NumberAssociatedCustomers
            props={props}
        />
    </NumberAssociatedCustomersContextProvider>
);

export default NumberAssociatedCustomersWithProvider;
